import OAuth from '../lib/oauth'

export const SET_LOGGED_IN = 'ui-settings/auth/SET_LOGGED_IN'
export const SET_LOGGED_OUT = 'ui-settings/auth/SET_LOGGED_OUT'
export const SET_LOGGING_IN = 'ui-settings/auth/SET_LOGGING_IN'
export const SET_ACCESS_TOKEN = 'ui-settings/auth/SET_ACCESS_TOKEN'
export const SET_USER = 'ui-settings/auth/SET_USER'
export const RESET = 'ui-settings/auth/RESET'
export const SET_ERRORED = 'ui-settings/auth/SET_ERRORED'
export const SET_DID_ATTEMPT_AUTO_LOGIN = 'ui-settings/auth/SET_DID_ATTEMPT_AUTO_LOGIN'

let TIMEOUT = null

export const defaultState = {
  loggedIn: false,
  loggingIn: false,
  error: null,
  fetchingUser: false,
  fetchedUser: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  expiresAt: null,
  didAttemptAutoLogin: false
}

export default function reducer (state = defaultState, action = {}) {
  if (action.type === RESET || action.type === SET_LOGGED_OUT) {
    return { ...defaultState }
  }

  const newState = { ...state }

  switch (action.type) {
    case SET_DID_ATTEMPT_AUTO_LOGIN:
      newState.didAttemptAutoLogin = action.payload
      return newState

    case SET_LOGGING_IN:
      newState.loggingIn = true
      return newState

    case SET_LOGGED_IN:
      newState.loggingIn = false
      newState.loggedIn = true
      return newState

    case SET_ACCESS_TOKEN:
      newState.accessToken = action.payload.access_token
      newState.refreshToken = action.payload.refresh_token
      newState.expiresAt = new Date(action.payload.expires_at)
      return newState

    case SET_ERRORED:
      newState.loggedIn = false
      newState.loggingIn = false
      newState.error = action.payload
      return newState

    case SET_USER:
      newState.user = action.payload
      return newState

    default:
      return newState
  }
}

export function attemptAutoLogin () {
  return (dispatch, getState) => {
    dispatch({ type: RESET })
    dispatch({ type: SET_LOGGING_IN })
    dispatch({ type: SET_DID_ATTEMPT_AUTO_LOGIN, payload: true })

    if (TIMEOUT !== null) {
      clearTimeout(TIMEOUT)
      TIMEOUT = null
    }

    OAuth
      .attemptAutoLogin()
      .then(payload => {
        dispatch({ type: SET_ACCESS_TOKEN, payload })
        return OAuth.me()
      })
      .then(payload => {
        dispatch({ type: SET_USER, payload })
        dispatch({ type: SET_LOGGED_IN })
        return payload
      })
      .catch(err => {
        console.log(`[ducks/auth/attemptAutoLogin] ${err.message}`)
        dispatch({
          type: SET_ERRORED,
          payload: null
        })
      })
  }
}

export function login (username, password, remember) {
  return (dispatch, getState) => {
    dispatch({ type: RESET })
    dispatch({ type: SET_LOGGING_IN })

    if (TIMEOUT !== null) {
      clearTimeout(TIMEOUT)
      TIMEOUT = null
    }

    return OAuth
      .login(username, password, remember)
      .then(payload => {
        dispatch({ type: SET_ACCESS_TOKEN, payload })
        return OAuth.me()
      })
      .then(payload => {
        dispatch({ type: SET_USER, payload })
        dispatch({ type: SET_LOGGED_IN })
        return payload
      })
      .catch(err => {
        dispatch({
          type: SET_ERRORED,
          payload: err.message
        })
      })
  }
}



// WEBPACK FOOTER //
// ./ducks/auth.js